import { db } from '@/data/firebase/config';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import {
  collection,
  documentId,
  getDocs,
  query,
  where,
} from 'firebase/firestore';

const FIRESTORE_IN_QUERY_LIMIT = 30;

export async function getDisabledUserIds(
  userIds: string[],
): Promise<Set<string>> {
  const uniqueIds = Array.from(new Set(userIds)).filter(Boolean);
  const disabledIds = new Set<string>();
  if (uniqueIds.length === 0) return disabledIds;

  const chunks: string[][] = [];
  for (let i = 0; i < uniqueIds.length; i += FIRESTORE_IN_QUERY_LIMIT) {
    chunks.push(uniqueIds.slice(i, i + FIRESTORE_IN_QUERY_LIMIT));
  }

  // Deliberately no try/catch here: if Firestore is unreachable, this should
  // fail loudly (reject) rather than silently return an empty Set, which
  // would fail OPEN and treat every disabled user as enabled. Callers must
  // handle the rejection themselves.
  const snapshots = await Promise.all(
    chunks.map((chunk) =>
      getDocs(
        query(
          collection(db, DOCUMENTS_DB.USERS),
          where(documentId(), 'in', chunk),
        ),
      ),
    ),
  );

  snapshots.forEach((snapshot) => {
    snapshot.docs.forEach((docSnap) => {
      // Intentionally strict: self-registered users have no `isEnabled` field
      // at all, so they must NOT be treated as disabled. Do not simplify this
      // to `!isEnabled`, which would silently break that case.
      if (docSnap.data().isEnabled === false) {
        disabledIds.add(docSnap.id);
      }
    });
  });

  return disabledIds;
}
